import React, { useState, useEffect } from "react";
import { supabase } from "./supabaseClient";
import { useNavigate } from "react-router-dom";
import "./App.css";

export default function UpdatePassword() {
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(false);
  const [sessionChecked, setSessionChecked] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Supabase already restores session via email link
    supabase.auth.getSession().then(({ data, error }) => {
      if (!data?.session) {
        setMessage("❌ Auth session missing! Please try the link again.");
      }
      setSessionChecked(true);
    });
  }, []);

  async function handleUpdate(e) {
    e.preventDefault();
    setLoading(true);

    const { error } = await supabase.auth.updateUser({ password });

    if (error) {
      setMessage("❌ " + error.message);
    } else {
      setMessage("✅ Password updated! Redirecting...");
      setTimeout(() => navigate("/"), 2000);
    }

    setLoading(false);
  }

  return (
    <div className="auth-wrapper">
      <div className="login-container">
        <h2>Reset Your Password</h2>
        {message && <p className="login-message">{message}</p>}

        {sessionChecked && (
          <form onSubmit={handleUpdate}>
            <input
              type="password"
              placeholder="New Password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
            <button type="submit" disabled={loading}>
              {loading ? "Updating..." : "Update Password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
}
